import { useEffect } from 'react';

export function useBodyScrollLock(isLocked = true) {
  useEffect(() => {
    if (!isLocked) return undefined;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isLocked]);
}
